import React from "react";

import Toggle from "platopulse/components/Toggle.jsx";

const ChartSettingToggle = ({ value, onChange }) =>
    <Toggle
        value={value}
        onChange={onChange}
    />

export default ChartSettingToggle;



// WEBPACK FOOTER //
// ./visualizations/components/settings/ChartSettingToggle.jsx